module.exports = __webpack_public_path__ + "static/medica-6e5a94484bb3df1507cbe8d37487ae66.webp";